import { useContext } from 'react';

import AuthContext from './AuthContext';

const useAuth = (context = AuthContext) => useContext(context);

export default useAuth;
